export const HELP_CENTRE_BANNER_FLAG_KEY = "help-centre-banner-enabled";

/**
 * Client-side LaunchDarkly flags consumed by this app.
 * Add new flags here — they must be listed before `useFlags()` will return them.
 */
export const CLIENT_SIDE_LD_FLAGS = {
    "in-store-disabled": false,
    "in-store-exclusive-shop-tile": false,
    "help-centre-banner-enabled": false,
    "site-next-welcome-modal": { enabled: false },
    "all-categories-wording": "all",
    "frites-redirections-list": { enable: false, values: [] },
} as const;
